import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";
import axios from "axios";

const Logo = ({ logoClass }) => {
  const [siteInfo, setSiteInfo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get("https://backend.elveescrubs.com/688787d8ff144c502c7f5cffaafe2cc588d86079f9de88304c26b0cb99ce91c6/api/page/site-info/")
      .then((res) => setSiteInfo(res.data))
      .catch((err) => {
        console.error("Failed to load site info:", err);
        setError("Failed to load");
      });
  }, []);

  if (error) {
    return (
      <div className={clsx(logoClass, "text-danger text-sm")}>
        Failed to load site info
      </div>
    );
  }

  return (
    <div className={clsx(logoClass)}>
      <Link to={process.env.PUBLIC_URL + "/"} className="flex items-center gap-2">
        {siteInfo?.logo ? (
          <img
            alt={siteInfo.site_name || "Logo"}
            src={siteInfo.logo}
            className="logo-from-a"
            loading="lazy"
          />
        ) : (
          <span className="text-xl font-bold text-black">
            {siteInfo?.site_name}
          </span>
        )}
      </Link>
    </div>
  );
};

Logo.propTypes = {
  logoClass: PropTypes.string
};

export default Logo;
